import { render, staticRenderFns } from "./DispatchCar.vue?vue&type=template&id=2c19216d&scoped=true&"
import script from "./DispatchCar.vue?vue&type=script&lang=js&"
export * from "./DispatchCar.vue?vue&type=script&lang=js&"
import style0 from "./DispatchCar.vue?vue&type=style&index=0&id=2c19216d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c19216d",
  null
  
)

export default component.exports